{
  "generatedAt": "2026-10-18T17:35:00.000Z",
  "entryCount": 165,
  "entries": [
    {
      "id": "2026-10-18-editor-color-styles-and-color-wheel",
      "date": "2026-10-18",
      "weekKey": "2026-10-12",
      "title": "Save color styles and pick colors from a wheel",
      "summary": "Save a color as a style and apply it to text, buttons, icons, images, dividers, social icons, tables, and section fills. Linked colors update together when you edit the style. The swatch opens a color wheel with a shade field, an eyedropper, and a contrast mark.",
      "tags": [
        "Editor"
      ],
      "commitShas": [
        "2b1a890094ba969681e76b955d911868e10fa0e6"
      ]
    },
    {
      "id": "2026-10-06-editor-type-styles",
      "date": "2026-10-06",
      "weekKey": "2026-10-05",
      "title": "Save and reuse type styles",
      "summary": "Save the formatting on a text block as a type style and apply it to other text blocks and buttons. Linked text updates when you edit the style. Styles stay in the project, and on Pro they can be shared with the team.",
      "tags": [
        "Editor"
      ],
      "commitShas": [
        "8846614680b57e776b4b131508aaee63b415c9c0"
      ]
    },
    {
      "id": "2026-09-22-editor-copy-link-to-canvas-selection",
      "date": "2026-09-22",
      "weekKey": "2026-09-21",
      "title": "Copy a link to the current canvas selection",
      "summary": "Right-click Copy link to selection or press Cmd+L to copy a project URL with ?block=. The address bar updates as you select, so a teammate opens the same block or section. Comment links still use ?comment= alongside it.",
      "tags": [
        "Editor",
        "Collaboration"
      ],
      "commitShas": []
    },
    {
      "id": "2026-09-21-collaboration-comment-share-links-and-read-state",
      "date": "2026-09-21",
      "weekKey": "2026-09-21",
      "title": "Copy a comment link, and threads mark read as you open them",
      "summary": "Each thread can copy a share URL with ?comment= so a teammate lands on that pin. Opening a comment marks it read. You can mark it unread from the thread menu, and delete is in the same menu.",
      "tags": [
        "Collaboration"
      ],
      "commitShas": [
        "847dbc3075f44ee6a8170035b501dd2d299faac2"
      ]
    },
    {
      "id": "2026-09-21-collaboration-tab-completes-comment-mentions",
      "date": "2026-09-21",
      "weekKey": "2026-09-21",
      "title": "Tab finishes a mention instead of jumping comments",
      "summary": "In a comment mention list, Tab now accepts the highlighted name. It no longer moves focus to the next comment on the canvas.",
      "tags": [
        "Collaboration"
      ],
      "commitShas": [
        "8a22f5dff412e8460db687fbce4dbbfb95173c33"
      ]
    },
    {
      "id": "2026-09-21-editor-compose-links-light-text-and-group-select",
      "date": "2026-09-21",
      "weekKey": "2026-09-21",
      "title": "Paste links in compose, keep light text readable, and select within a group",
      "summary": "Pasting into the compose link field fills the URL instead of replacing your highlight. Reopening a link shows Update link (grey until the URL changes) and Cancel. Very light text gets a grey chip in that field only, with a short note under the box. Group sections now list Select within group in the breadcrumb menu.",
      "tags": [
        "Editor"
      ],
      "commitShas": [
        "d7004794e69ca847cb1142059333e76bf2f69747",
        "d70fac9895be0977d8e44bc77c3deffb72964368",
        "6b9ef08300cc7b5cdbe307e1d8d7f039f42e9d3d"
      ]
    },
    {
      "id": "2026-09-20-collaboration-notification-settings-and-unread-badge",
      "date": "2026-09-20",
      "weekKey": "2026-09-14",
      "title": "Notification settings stick, and a red unread dot on the hub",
      "summary": "Preferences on the Notifications page now save and control mentions, replies, and being added to a team or project. A red dot appears on the projects-page Notifications item when something new arrives, then clears when you open that page.",
      "tags": [
        "Collaboration",
        "Projects"
      ],
      "commitShas": [
        "d8a8b8955e8f31c2f8fef18c5749a26bf76ac999"
      ]
    },
    {
      "id": "2026-09-20-projects-hub-sort-views-and-comment-pin-avatars",
      "date": "2026-09-20",
      "weekKey": "2026-09-14",
      "title": "Comment pins show avatars, and the projects hub gets sort and list views",
      "summary": "Canvas comment pins show the author's avatar, plus the last unique person who replied. The comment sidebar lists reply counts under a three-line preview, and collaborator avatars stay visible in the editor header in comment mode. On the projects page you can sort by recently viewed, last edited, or newest created, and switch between grid and list.",
      "tags": [
        "Collaboration",
        "Projects"
      ],
      "commitShas": []
    },
    {
      "id": "2026-09-18-collaboration-comments-get-mentions-markdown-and-reply-notific",
      "date": "2026-09-18",
      "weekKey": "2026-09-14",
      "title": "Comments get mentions, markdown, and reply notifications",
      "summary": "Tag teammates with @ in a comment or reply, with a Figma-style name ghost as you type. Compose supports lists, links, and Slack-style *italic* and **bold** that convert as you type so the markers disappear. Shift+Enter adds a new line. You get notified when someone replies or mentions you, and the editor Share button is now Invite.",
      "tags": [
        "Collaboration"
      ],
      "commitShas": [
        "bead20c8c162ea11e49d4a4e9b2223de6ed9ba72"
      ]
    },
    {
      "id": "2026-09-12-projects-project-previews-update-in-the-background",
      "date": "2026-09-12",
      "weekKey": "2026-09-07",
      "title": "Project previews update in the background",
      "summary": "Leaving a project for the hub no longer waits on a screenshot. Previews keep capturing after you hit Back, and off-site images now appear in those thumbs.",
      "tags": [
        "Editor",
        "Projects"
      ],
      "commitShas": [
        "82299f682b5f2cc21ef2bed7ab308c2917136968"
      ]
    },
    {
      "id": "2026-09-12-export-force-export-warns-that-preflight-has-not-run",
      "date": "2026-09-12",
      "weekKey": "2026-09-07",
      "title": "Force export warns that Preflight has not run",
      "summary": "The header Export path is now Force export, with a warning that downloads skip Preflight checks. Button and icon export also load Font Awesome paths correctly again.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "87a302e405166889db59729e6c636a80a20fe3e9",
        "a6a2c8f0b233d8c0743ec4e448c4d1cda0722824"
      ]
    },
    {
      "id": "2026-08-05-editor-added-background-fill-to-all-appearance-category",
      "date": "2026-08-05",
      "weekKey": "2026-08-03",
      "title": "Added background fill to all appearance category properties",
      "summary": "Better custom element thumb capture; Added 4 column section and better drag handling in UI; Color widget bugs (still old widget); Updates to spacer mobile handling for more features; Added background fill to all appearance category properties; and some small UI bug fixes.",
      "tags": [
        "Editor",
        "Export",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "65cd5a7d3ce48d7d8642c1ea8459586ba0970808",
        "888125aa29997e930c02d674504e940e6786bcbb",
        "f036d7cc8e72465e2af8939a4fb5c4f5b962e150",
        "ff3ba247881de85571aac238f382691b381ddc4b",
        "d938eb57e03355c963b2db0b1a76fffbe35589ad",
        "cd26deedd4af7b1f0a4a7b1470409fe3484c91a2"
      ]
    },
    {
      "id": "2026-07-27-api-moved-branding-permission-checkboxes-to-post-mag",
      "date": "2026-07-27",
      "weekKey": "2026-07-27",
      "title": "Moved branding permission checkboxes to post magic link; breadcrub flips dynamically; Multi-select allows 'Group' via new Props button",
      "summary": "Team level roles reflect as much in the Project Share modal, and moved branding permission checkboxes to post magic link; breadcrub flips dynamically; Multi-select allows 'Group' via new Props button.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Export",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "4e2ef1559f1ac4e002bb3d12fef37583b92b4141",
        "134e952171b02cd97f1d843ffcaebc0aa38a2275"
      ]
    },
    {
      "id": "2026-07-27-editor-fix-right-click-menu-and-scrollbar-pointers",
      "date": "2026-07-27",
      "weekKey": "2026-07-27",
      "title": "Fix right click menu and scrollbar pointers",
      "summary": "Bug fix; Fix right click menu and scrollbar pointers; and minor UI updates.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "57247e9e48ffcff8f34c856b17a6256a78d90dac",
        "74693aec663860b7a2dd49fd86b7cff2d5bc77b5",
        "8aa730fc05b1e6269b3f5ac2fb0c42a22e7df66d"
      ]
    },
    {
      "id": "2026-07-24-api-various-bug-fixes",
      "date": "2026-07-24",
      "weekKey": "2026-07-20",
      "title": "Various bug fixes",
      "summary": "Various bug fixes.",
      "tags": [
        "API",
        "Collaboration",
        "Editor",
        "Infrastructure",
        "Landing",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "bcefc23eb5dae842cdc40ddf79e1fcf8c3190e1f"
      ]
    },
    {
      "id": "2026-07-22-api-massive-updates-to-properties-panels-and-element",
      "date": "2026-07-22",
      "weekKey": "2026-07-20",
      "title": "Massive updates to Properties Panels and Element enhancements",
      "summary": "Massive updates to Properties Panels and Element enhancements.",
      "tags": [
        "API",
        "Collaboration",
        "Editor",
        "Export",
        "Landing",
        "Security",
        "Testing"
      ],
      "commitShas": [
        "3b01938fad71bbde89aa3d04523ae5dae5667ce5"
      ]
    },
    {
      "id": "2026-07-22-editor-right-click-pointer-bug-comments-drag-bug-font-a",
      "date": "2026-07-22",
      "weekKey": "2026-07-20",
      "title": "Right click pointer bug; Comments drag bug' Font autocomplete; Thumbnail consistency fix",
      "summary": "Right click pointer bug; Comments drag bug' Font autocomplete; Thumbnail consistency fix.",
      "tags": [
        "Editor",
        "Export",
        "Projects"
      ],
      "commitShas": [
        "b7ceeb65daa6f0952247c15bf5a0e52e7e764d70"
      ]
    },
    {
      "id": "2026-07-21-api-ship-editor-export-chrome-and-harden-account-e2e",
      "date": "2026-07-21",
      "weekKey": "2026-07-20",
      "title": "Ship editor Export chrome and harden account E2E for trash and seat limits",
      "summary": "Ship editor Export chrome and harden account E2E for trash and seat limits.",
      "tags": [
        "API",
        "Account",
        "Editor",
        "Export",
        "Infrastructure",
        "Landing",
        "Testing"
      ],
      "commitShas": [
        "64ce2abe6697322519ba4e980b40e93772c4913a"
      ]
    },
    {
      "id": "2026-07-21-editor-adding-email-support-to-social-media-icons-eleme",
      "date": "2026-07-21",
      "weekKey": "2026-07-20",
      "title": "Adding email support to social media icons element",
      "summary": "Adding email support to social media icons element.",
      "tags": [
        "Editor",
        "Export",
        "Landing",
        "Testing"
      ],
      "commitShas": [
        "bdf04d8e8f855808f92038c346fea0fdbc03479f"
      ]
    },
    {
      "id": "2026-07-21-infrastructure-bump-shell-quote-override-to-1-10-0-for-npm-audi",
      "date": "2026-07-21",
      "weekKey": "2026-07-20",
      "title": "Bump shell-quote override to 1.10.0 for npm audit",
      "summary": "Bump shell-quote override to 1.10.0 for npm audit.",
      "tags": [
        "Infrastructure"
      ],
      "commitShas": [
        "4a69dd7d3a7b6e6fc341d5277c993123ed13a496"
      ]
    },
    {
      "id": "2026-07-20-collaboration-fix-z-index-layer-issue-where-comments-appeared-",
      "date": "2026-07-20",
      "weekKey": "2026-07-20",
      "title": "Fix z index layer issue where comments appeared above control bars",
      "summary": "Fix z index layer issue where comments appeared above control bars.",
      "tags": [
        "Collaboration",
        "Editor"
      ],
      "commitShas": [
        "59ba2b2337e5201f005241313f1da1c7183f6232"
      ]
    },
    {
      "id": "2026-07-19-api-polish-preflight-custom-element-thumbs-editor-se",
      "date": "2026-07-19",
      "weekKey": "2026-07-13",
      "title": "Polish preflight, custom-element thumbs, editor selection, breadcrumbs, Shift+table ranges, project rename, drop hotspot, and navigation UX, capture thumbs at true aspect ratio, treat example.com links as broken, and update the changelog",
      "summary": "Digital twins of off site images for thumb capture; Fix tier policy bug where the policy file can become wiped out; Fix project thumb generation bug; New feature for trashed projects; Email Owners and Editors on project status change; and polish preflight, custom-element thumbs, editor selection, breadcrumbs, Shift+table ranges, project rename, drop hotspot, and navigation UX, capture thumbs at true aspect ratio, treat example.com links as broken, and update the changelog.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Export",
        "Infrastructure",
        "Landing",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "f77c15632374702e6a8c17f43035a7dbaa72d5ee",
        "27ab68298076402efe6fd6b760eba277bda3a9e5",
        "36a1f768167fe8cadb8d12787fc7a0b891b8da0d",
        "042c478b0cd4dff0f23ab235a9d5671f0ccaff74",
        "95654178276285bc79b1976539f21fff45b86eca"
      ]
    },
    {
      "id": "2026-07-17-account-fixing-some-tracked-files",
      "date": "2026-07-17",
      "weekKey": "2026-07-13",
      "title": "Fixing some tracked files",
      "summary": "Fixing some tracked files.",
      "tags": [
        "Account",
        "Testing"
      ],
      "commitShas": [
        "62488457d28a98ef7e536b3e1ac94ccef0557753"
      ]
    },
    {
      "id": "2026-07-17-api-final-updates-to-social-media-icons-element",
      "date": "2026-07-17",
      "weekKey": "2026-07-13",
      "title": "Final updates to social media icons element",
      "summary": "Final updates to social media icons element.",
      "tags": [
        "API",
        "Editor",
        "Export",
        "Landing",
        "Testing"
      ],
      "commitShas": [
        "0735729d654c999621cf21d38429e2e502198cd5"
      ]
    },
    {
      "id": "2026-07-13-api-revert-adding-social-media-icons-support",
      "date": "2026-07-13",
      "weekKey": "2026-07-13",
      "title": "Revert \"Adding social media icons support\"",
      "summary": "Fix for social media icons; Revert \"Adding social media icons support\"; and adding social media icons support.",
      "tags": [
        "API",
        "Editor",
        "Export",
        "Infrastructure",
        "Landing",
        "Testing"
      ],
      "commitShas": [
        "36efc95a5f56935ffbdd6567c8be26108ca2c7a9",
        "f03049fdda3a03fcf81660243d98a11a95182cc0",
        "64e0b70bb766c51574e0848fb8fcae12813adfd5",
        "18ddb96f92b3448e5294f77111e2500854ba91e3"
      ]
    },
    {
      "id": "2026-07-10-api-fix-thumbnail-bug-for-non-cors-images-curl-first",
      "date": "2026-07-10",
      "weekKey": "2026-07-06",
      "title": "Fix thumbnail bug for non-CORS images (curl first)",
      "summary": "Fix thumbnail bug for non-CORS images (curl first); Fix bug in icons not converting to PNG; and fixed Pixabay insert and now it imports images.",
      "tags": [
        "API",
        "Editor",
        "Export",
        "Landing",
        "Testing"
      ],
      "commitShas": [
        "0144447234472584ca2456e4ac0919167ac479b1",
        "65c12dbf37ff0e9bcf2c89384a7d9238fb5c97e9",
        "8e2e4b879b65f5f80ca5344612316be2bdfe0672"
      ]
    },
    {
      "id": "2026-07-10-editor-fix-bug-where-section-and-layout-padding-were-re",
      "date": "2026-07-10",
      "weekKey": "2026-07-06",
      "title": "Fix bug where section and layout padding were reverting to locked state",
      "summary": "Added independent border control for groups and column sections; Fix bug where section and layout padding were reverting to locked state; Better text block style matching; Added border and shadow props for column sections; Fix bug where you couldn't set column background color (regression); and various bug fixes.",
      "tags": [
        "Editor",
        "Export",
        "Landing",
        "Testing"
      ],
      "commitShas": [
        "ef1c83f740342870cbacbc59442d6cbdc7542e28",
        "1f03f71fc3e246eaceb8beee01a1a5526f15bea0",
        "c3668210b0adb5abb1b3ba9c40c48d6cba54a522",
        "a30f5f86eaa2ae95eb4ce0164c177282f0dd5a31",
        "12e6775f8e1333e2f14959503223af3aaf11a5b9",
        "d9796d23c1d6f049951ebd0c2fcb9a3ace5eeaf4"
      ]
    },
    {
      "id": "2026-07-10-landing-various-ui-fixes",
      "date": "2026-07-10",
      "weekKey": "2026-07-06",
      "title": "Various UI fixes",
      "summary": "Various UI fixes.",
      "tags": [
        "Landing",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "1d40103c009ef794dde2d06060fa351dbb5a7bbd"
      ]
    },
    {
      "id": "2026-07-09-api-total-overhaul-of-roles-and-notifications",
      "date": "2026-07-09",
      "weekKey": "2026-07-06",
      "title": "Total overhaul of ROLES and Notifications",
      "summary": "Unify project and edit file menus; Bug fixes after last deploy; and total overhaul of ROLES and Notifications.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Export",
        "Landing",
        "Projects",
        "Security",
        "Testing"
      ],
      "commitShas": [
        "9a7c48c7a7a204004e4b444a9ff289baf26dafad",
        "a3db5c9fcc9896863bdc98c7e7f3b2d89c2e90d3",
        "e14af9170e5ee5e33e9c606fc4b50a6d739254c3"
      ]
    },
    {
      "id": "2026-07-09-editor-fix-layering-issue-of-remote-pointers",
      "date": "2026-07-09",
      "weekKey": "2026-07-06",
      "title": "Fix layering issue of remote pointers",
      "summary": "Fix layering issue of remote pointers.",
      "tags": [
        "Editor"
      ],
      "commitShas": [
        "ee370913b58fcec207b6dab607db3830c94d6d97"
      ]
    },
    {
      "id": "2026-07-09-platform-ux-feedback-when-user-tries-to-duplicate-past-th",
      "date": "2026-07-09",
      "weekKey": "2026-07-06",
      "title": "UX feedback when user tries to duplicate past the maximum projects allowed for their tier (within the editor)",
      "summary": "UX feedback when user tries to duplicate past the maximum projects allowed for their tier (within the editor); Fix multiplayer for viewers (was gated); and production bug fix.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "c7eac7f7d501d2a39adb9daa1afec6fc7a60361a",
        "01d6147560cf8689e8a2c28c275cc278212870fa",
        "a3a15b3d1656bb6f43772b95ed9f02418fcabd71"
      ]
    },
    {
      "id": "2026-07-09-projects-project-title-inconsitency-bug-fix",
      "date": "2026-07-09",
      "weekKey": "2026-07-06",
      "title": "Project title inconsitency bug fix",
      "summary": "Project title inconsitency bug fix.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "aec912c932aadd634dc7a4d30bac359fa45eba65"
      ]
    },
    {
      "id": "2026-07-07-landing-fixed-search-bug-and-enhanced-search-feature",
      "date": "2026-07-07",
      "weekKey": "2026-07-06",
      "title": "Fixed search bug and enhanced search feature",
      "summary": "Fixed search bug and enhanced search feature.",
      "tags": [
        "Landing",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "9e83bd7544d2a836dc0b50584a54a1a4b2e014ab"
      ]
    },
    {
      "id": "2026-07-06-api-added-billing-cycles-with-actual-billing-still-s",
      "date": "2026-07-06",
      "weekKey": "2026-07-06",
      "title": "Added billing cycles, with actual billing still stubbed out, so we can time-limit free PRO accounts",
      "summary": "Changed the way duplicating projects works to make it easier to use; Fix project duplication bug; Fixed issue where cloning project didn't generate a thumb; and added billing cycles, with actual billing still stubbed out, so we can time-limit free PRO accounts.",
      "tags": [
        "API",
        "Account",
        "Landing",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "57a51cd8cb991e5da79738ac1ad1549edbc74763",
        "b1450b0cb4a869c4968c12dbf67a7ca8dd2273ee",
        "3e427cd1e432fff7e30d7591a43a414d5fda6190",
        "22518d161c759d9346303d7de0b07c248bf0564d"
      ]
    },
    {
      "id": "2026-07-06-export-update-projects-team-page",
      "date": "2026-07-06",
      "weekKey": "2026-07-06",
      "title": "Update projects team page",
      "summary": "Update projects team page.",
      "tags": [
        "Export",
        "Landing",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "d565ee3a7949bb9fbdbfd4401fa1aea9c16e94ee"
      ]
    },
    {
      "id": "2026-07-05-collaboration-bug-fixes",
      "date": "2026-07-05",
      "weekKey": "2026-06-29",
      "title": "Bug fixes",
      "summary": "Bug fixes.",
      "tags": [
        "Collaboration",
        "Landing"
      ],
      "commitShas": [
        "de39e851ddc3032879bacf6b29b8df3c0fb64df2"
      ]
    },
    {
      "id": "2026-07-05-editor-inherit-neighbour-element-styles-only-on-new-ele",
      "date": "2026-07-05",
      "weekKey": "2026-06-29",
      "title": "Inherit neighbour element styles only on new element drag from palette",
      "summary": "Fixed undo bug; better copy styles, and inherit neighbour element styles only on new element drag from palette.",
      "tags": [
        "Editor",
        "Testing"
      ],
      "commitShas": [
        "af9c4ebfd54a7f8bbef0b28ea580ce97e0591120",
        "f7fa49ad4d1d2f5551593e544a56da2de85d52f1"
      ]
    },
    {
      "id": "2026-07-05-platform-added-keyboard-support-for-copy-and-paste-styles",
      "date": "2026-07-05",
      "weekKey": "2026-06-29",
      "title": "Added keyboard support for copy and paste styles",
      "summary": "Added keyboard support for copy and paste styles.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "62abd1302d8967486c17c31112e6cd5ca7119290"
      ]
    },
    {
      "id": "2026-07-04-api-custom-element-gate-bug-fix-for-pro-made-request",
      "date": "2026-07-04",
      "weekKey": "2026-06-29",
      "title": "Custom element gate bug fix for PRO; made request upgrade path during alpha consistent",
      "summary": "Custom element gate bug fix for PRO; made request upgrade path during alpha consistent.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Export",
        "Landing",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "b800f50806e622f08a89e7db8e0fa2809ee5c47a"
      ]
    },
    {
      "id": "2026-07-04-editor-updated-default-mobile-alignment-for-text-blocks",
      "date": "2026-07-04",
      "weekKey": "2026-06-29",
      "title": "Updated default mobile alignment for text blocks to left-align",
      "summary": "Updated default mobile alignment for text blocks to left-align, and updated tier policy handling; tiny UI bug.",
      "tags": [
        "Editor",
        "Export",
        "Landing"
      ],
      "commitShas": [
        "006570635d58e287d010ca4bddc74f1e2c053fe8",
        "c231ea5f9f315fb02043c41bbfed0e1e93042ce4"
      ]
    },
    {
      "id": "2026-07-03-api-project-status-feature-added-mixed-ui-tweaks",
      "date": "2026-07-03",
      "weekKey": "2026-06-29",
      "title": "Project status feature added; mixed UI tweaks",
      "summary": "Project status feature added; mixed UI tweaks.",
      "tags": [
        "API",
        "Editor",
        "Export",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "183a67e76f6e59b373faf8358531efe84a29ac3d"
      ]
    },
    {
      "id": "2026-07-03-editor-updated-element-strokes-so-they-can-have-4-indep",
      "date": "2026-07-03",
      "weekKey": "2026-06-29",
      "title": "Updated element strokes so they can have 4 independent sizes",
      "summary": "New element for data tables; Tweak elements palette; Updated element strokes so they can have 4 independent sizes; and added changelog page.",
      "tags": [
        "Editor",
        "Export",
        "Infrastructure",
        "Landing",
        "Security",
        "Testing"
      ],
      "commitShas": [
        "b0f456066dc1334bd9610906fea6dabc717f98e8",
        "654fbcb9802eec21e9aa9410ff05809bac280acf",
        "ec3e6c3e804bdadb357342ccedd8f373ea9ec5c9",
        "a4de1330c1fa554c988463b5eff5d9fb83614a60"
      ]
    },
    {
      "id": "2026-07-03-export-updated-landing-page-ui-with-new-features",
      "date": "2026-07-03",
      "weekKey": "2026-06-29",
      "title": "Updated landing page UI with new features",
      "summary": "Updated landing page UI with new features.",
      "tags": [
        "Export",
        "Landing"
      ],
      "commitShas": [
        "e08b4f220eb406fea12624282f3061c1b2253690"
      ]
    },
    {
      "id": "2026-07-03-projects-added-a-on-hold-project-status",
      "date": "2026-07-03",
      "weekKey": "2026-06-29",
      "title": "Added a 'on hold' project status",
      "summary": "Added a 'on hold' project status.",
      "tags": [
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "5f437375818bfa301f8d1f01c33bc2addb9ad03b"
      ]
    },
    {
      "id": "2026-07-02-api-updated-properties-panel-vernacular-and-the-ai",
      "date": "2026-07-02",
      "weekKey": "2026-06-29",
      "title": "Updated Properties panel vernacular (and the AI)",
      "summary": "Group drag bugs; tweaks; Fixing some lint warnings; Added width control parameters to atoms; and updated Properties panel vernacular (and the AI).",
      "tags": [
        "API",
        "Editor",
        "Export",
        "Testing"
      ],
      "commitShas": [
        "1529b56d6a20a26f910f9c00ab5d4efec2a78a6d",
        "dc26f6f9baaf39890858037a01dd843d873164f7",
        "73fb98906997fceaa548c0b8189e2febd94a265a",
        "dd2451102c6b68747f18f429fd939dbd17e19875"
      ]
    },
    {
      "id": "2026-07-02-editor-added-groups-and-some-misc-ux-changes",
      "date": "2026-07-02",
      "weekKey": "2026-06-29",
      "title": "Added groups; and some misc UX changes",
      "summary": "Highlight chrome changes, and added groups; and some misc UX changes.",
      "tags": [
        "Editor",
        "Export",
        "Testing"
      ],
      "commitShas": [
        "3cff706dbcbd0daf6079a08a5f7538b92b670c4e",
        "24ffbc7eb6a179af12dee45f46e77e2b6d8b40bc"
      ]
    },
    {
      "id": "2026-07-02-platform-save-icon-during-project-save-an-alert-toast-on-",
      "date": "2026-07-02",
      "weekKey": "2026-06-29",
      "title": "Save icon during project save an alert toast on failure",
      "summary": "Save icon during project save an alert toast on failure.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "ed01674c60488adc556df74006dee7399f1add6f"
      ]
    },
    {
      "id": "2026-07-01-api-editor-improvements-and-changes-textblocks-and-c",
      "date": "2026-07-01",
      "weekKey": "2026-06-29",
      "title": "Editor improvements and changes (textblocks and columns)",
      "summary": "Editor improvements and changes (textblocks and columns), and initial AI assistant.",
      "tags": [
        "API",
        "Account",
        "Editor",
        "Export",
        "Security",
        "Testing"
      ],
      "commitShas": [
        "0b48d96f1132003fcd6abd7245b1963c56edeeb6",
        "1544aa97b0fb6c29ea9ab7474c921e4de2e58f29"
      ]
    },
    {
      "id": "2026-07-01-collaboration-fix-editor-presence-e2e-for-websocket-protocol-a",
      "date": "2026-07-01",
      "weekKey": "2026-06-29",
      "title": "Fix editor presence E2E for WebSocket protocol and add vitest",
      "summary": "Fix editor presence E2E for WebSocket protocol and add vitest.",
      "tags": [
        "Collaboration",
        "Infrastructure"
      ],
      "commitShas": [
        "9244e10520d5021f0f1e5b4552114a9780c0daca"
      ]
    },
    {
      "id": "2026-07-01-projects-added-shared-teams-section-to-projects-page",
      "date": "2026-07-01",
      "weekKey": "2026-06-29",
      "title": "Added SHARED TEAMS section to projects page",
      "summary": "Added SHARED TEAMS section to projects page, and state app is alpha and add report bug link.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "3e0c97b6fab74b1170f4d165ef74e5a575b0eeda",
        "1db9d4cffe40d9d0d5334db15aa1f28ff8dfc3b2"
      ]
    },
    {
      "id": "2026-06-29-api-basic-custom-elements",
      "date": "2026-06-29",
      "weekKey": "2026-06-29",
      "title": "Basic 'Custom Elements'",
      "summary": "Custom element thumbs, and basic 'Custom Elements'.",
      "tags": [
        "API",
        "Account",
        "Editor",
        "Export",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "a9d7ecf48d9b1de96c58730e6237ebf3a9f2ef9f",
        "ced21838b125ac24f41d9eb8f3fa257ecc50b0e8"
      ]
    },
    {
      "id": "2026-06-29-editor-mouse-cursor-click-drag-highlight-capability",
      "date": "2026-06-29",
      "weekKey": "2026-06-29",
      "title": "Mouse cursor click-drag highlight capability",
      "summary": "Columnar section name updated; Cursor drag and clone with option key; Control bar and mobile alignment; and mouse cursor click-drag highlight capability.",
      "tags": [
        "Editor",
        "Export",
        "Testing"
      ],
      "commitShas": [
        "3045ba268ee3551fc398ff62880bddcb8f0ad4f9",
        "766cbccb9c92a792e3c6776cac49a9a45d53f890",
        "ed640dfe54493e8e20825f12d7e46ac6e54a51fe",
        "ff48f8e6efcde6b0201eba6618f3537bc4de5641"
      ]
    },
    {
      "id": "2026-06-29-platform-click-drag-to-select-and-cmd-a-to-select-all",
      "date": "2026-06-29",
      "weekKey": "2026-06-29",
      "title": "Click-drag to select and Cmd+A to select all",
      "summary": "Click-drag to select and Cmd+A to select all.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "5d6731163598d07ebb9338594c3b0f7c6c10e48a"
      ]
    },
    {
      "id": "2026-06-25-editor-moved-breadcrumb-to-highlight-and-can-now-multi-",
      "date": "2026-06-25",
      "weekKey": "2026-06-22",
      "title": "Moved breadcrumb to highlight and can now multi-select elements",
      "summary": "Moved breadcrumb to highlight and can now multi-select elements.",
      "tags": [
        "Editor",
        "Testing"
      ],
      "commitShas": [
        "b7112bd54ee9ade614703f59a1e35d5966e59f96"
      ]
    },
    {
      "id": "2026-06-22-api-fix-bug-where-missing-avatar-image-forces-welcom",
      "date": "2026-06-22",
      "weekKey": "2026-06-22",
      "title": "Fix bug where missing avatar image forces welcome modal to appear again",
      "summary": "Improve multicursor speed; Better opt in language on welcome modal; Fix bug where missing avatar image forces welcome modal to appear again; and fixing production.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Infrastructure",
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "a29ebae431d977c384a79f36798ed8e38cb8915a",
        "31223f34f2a8a8550fd36b43abe64001ce3928b0",
        "411d64284980737c5bae2c970ba10e47dbc2cc2b",
        "9d4fafadef99b8f5db2f41398be654ebf3f2cb61"
      ]
    },
    {
      "id": "2026-06-22-collaboration-bug-in-collab-websocket-pipeline-relative-path",
      "date": "2026-06-22",
      "weekKey": "2026-06-22",
      "title": "Bug in collab websocket pipeline (relative path)",
      "summary": "Better cursor latency; better cursor size; Latency updatse to multi-cursor; and bug in collab websocket pipeline (relative path).",
      "tags": [
        "Collaboration",
        "Editor",
        "Testing"
      ],
      "commitShas": [
        "ad7e7f4b00879d041031c0b06543b615f026fa46",
        "e07e23cd8448511109041c7407c556199e006cf6",
        "e04935a809c533c9203544a07befcb4b93325c43"
      ]
    },
    {
      "id": "2026-06-22-landing-fixing-production-4",
      "date": "2026-06-22",
      "weekKey": "2026-06-22",
      "title": "Fixing production 4",
      "summary": "Fixing production 4, and fixing production 3.",
      "tags": [
        "Landing"
      ],
      "commitShas": [
        "0a93e57344c3628416765b80eb9952bc68d3f40b",
        "96bf1d19bf33d7a9b55277c370e046ea1b05f75d"
      ]
    },
    {
      "id": "2026-06-22-platform-fixing-production-2",
      "date": "2026-06-22",
      "weekKey": "2026-06-22",
      "title": "Fixing production 2",
      "summary": "Fixing production 2.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "171060ef1fd6dbc456dc9bfc31420774a45c6c16"
      ]
    },
    {
      "id": "2026-06-21-api-websocket-pipeline-for-all-collaboration-data",
      "date": "2026-06-21",
      "weekKey": "2026-06-15",
      "title": "Websocket pipeline for all collaboration data",
      "summary": "Added new test cases for Websocket pipeline, and websocket pipeline for all collaboration data.",
      "tags": [
        "API",
        "Collaboration",
        "Infrastructure",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "5f38ed8f5ab12f58c226caf211785b10abd565fe",
        "d6f1331d3a088e48f3e0847c276ab9bba1458685"
      ]
    },
    {
      "id": "2026-06-21-collaboration-tweak-chat-feature-and-added-ui-hint",
      "date": "2026-06-21",
      "weekKey": "2026-06-15",
      "title": "Tweak chat feature and added UI hint",
      "summary": "Tweak chat feature and added UI hint.",
      "tags": [
        "Collaboration",
        "Editor",
        "Testing"
      ],
      "commitShas": [
        "fe2eb36c745e07987e051dca313d2ae19b296339"
      ]
    },
    {
      "id": "2026-06-19-api-multiplayer-pointers-with-chat-fixed-new-element",
      "date": "2026-06-19",
      "weekKey": "2026-06-15",
      "title": "Multiplayer pointers with chat; Fixed new element drag bug; Fixed preflight image description bug",
      "summary": "Multiplayer pointers with chat; Fixed new element drag bug; Fixed preflight image description bug.",
      "tags": [
        "API",
        "Collaboration",
        "Editor",
        "Export",
        "Infrastructure",
        "Testing"
      ],
      "commitShas": [
        "421294006f0636e8bd71102b8286fc3b499adbef"
      ]
    },
    {
      "id": "2026-06-16-api-refactor-button-icons-on-fa-inline-svgs-will-wor",
      "date": "2026-06-16",
      "weekKey": "2026-06-15",
      "title": "Refactor button icons - on FA inline SVGs will work",
      "summary": "Multiplayer cursor; Svg to png icon conversion and hosting; and refactor button icons - on FA inline SVGs will work.",
      "tags": [
        "API",
        "Collaboration",
        "Editor",
        "Export",
        "Testing"
      ],
      "commitShas": [
        "21dfe10b2526a599b45e63d63b900f4f52bca1f1",
        "f0186dbff237eb988cc84bb667c130bb728453b5",
        "6ad23cd456813567460f261fa6934c72c072b88a"
      ]
    },
    {
      "id": "2026-06-16-platform-fix-dragging-issue-elements-were-stuck-in-corner",
      "date": "2026-06-16",
      "weekKey": "2026-06-15",
      "title": "Fix dragging issue (elements were stuck in corner while dragging)",
      "summary": "Fix dragging issue (elements were stuck in corner while dragging).",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "ee669e3c96dc8a7c9656a0770a52fa56ccc86106"
      ]
    },
    {
      "id": "2026-06-14-api-canva-api-not-working-trying-a-few-things-in-pro",
      "date": "2026-06-14",
      "weekKey": "2026-06-08",
      "title": "Canva API not working, trying a few things in prod",
      "summary": "Canva API not working, trying a few things in prod, and added Canva integration.",
      "tags": [
        "API",
        "Infrastructure",
        "Testing"
      ],
      "commitShas": [
        "b39e7a89eb7b2aae30df7d2f553ddce75b5ae250",
        "d581a4458b6492abbe42c3fa7a305e6f207d170a"
      ]
    },
    {
      "id": "2026-06-14-editor-fixed-corner-radius-on-main-layout-fixed-highlig",
      "date": "2026-06-14",
      "weekKey": "2026-06-08",
      "title": "Fixed corner radius on main layout, fixed highlight chrome, made share and invite buttons pills to match landing page designs",
      "summary": "Fixed corner radius on main layout, fixed highlight chrome, made share and invite buttons pills to match landing page designs.",
      "tags": [
        "Editor",
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "840f19e221e2909e6258aa7258d47e9af6770c1a"
      ]
    },
    {
      "id": "2026-06-13-api-test-cases-website-updates-legal-casl-gdpr-secur",
      "date": "2026-06-13",
      "weekKey": "2026-06-08",
      "title": "Test cases, website updates, legal, CASL, GDPR, Security, Privacy, and more. This is a big one",
      "summary": "Upgrade to Vite 8 for security dependency issues in github deployment workflow, and test cases, website updates, legal, CASL, GDPR, Security, Privacy, and more. This is a big one.",
      "tags": [
        "API",
        "Account",
        "Editor",
        "Infrastructure",
        "Landing",
        "Projects",
        "Security",
        "Testing"
      ],
      "commitShas": [
        "3af7e0babaf4657292233179e5d48e5a789d24c2",
        "db814bb121853a09212a834d7f418d8e2c9a758c"
      ]
    },
    {
      "id": "2026-06-12-editor-landing-page-changes-6",
      "date": "2026-06-12",
      "weekKey": "2026-06-08",
      "title": "Landing page changes 6",
      "summary": "Landing page changes 6.",
      "tags": [
        "Editor",
        "Infrastructure",
        "Landing"
      ],
      "commitShas": [
        "3d5aa0837d4d1fd6e0573f0f54e560eebcb11598"
      ]
    },
    {
      "id": "2026-06-11-api-fix-new-account-bug",
      "date": "2026-06-11",
      "weekKey": "2026-06-08",
      "title": "Fix new account bug",
      "summary": "Fix new account bug.",
      "tags": [
        "API",
        "Account"
      ],
      "commitShas": [
        "9b61acd73b251a07c6a54406c22c22de6a3d0bb7"
      ]
    },
    {
      "id": "2026-06-11-editor-landing-page-changes-4",
      "date": "2026-06-11",
      "weekKey": "2026-06-08",
      "title": "Landing page changes 4",
      "summary": "Landing page changes 4, and landing page changes 3.",
      "tags": [
        "Editor",
        "Landing"
      ],
      "commitShas": [
        "b1169f22403e7d375b3bd77ef6643ef63ccc49a4",
        "8e551832f3fe01e9abdba444fb14519918cca458"
      ]
    },
    {
      "id": "2026-06-11-landing-landing-page-changes-5",
      "date": "2026-06-11",
      "weekKey": "2026-06-08",
      "title": "Landing page changes 5",
      "summary": "Landing page changes 5.",
      "tags": [
        "Landing"
      ],
      "commitShas": [
        "64155beaec6594027c5affcccf35fee18cdc330a"
      ]
    },
    {
      "id": "2026-06-10-editor-landing-page-changes-2",
      "date": "2026-06-10",
      "weekKey": "2026-06-08",
      "title": "Landing page changes 2",
      "summary": "Landing page changes 2, and landing page changes 1.",
      "tags": [
        "Editor",
        "Landing"
      ],
      "commitShas": [
        "eb323f68ca89fd74ca71e874ae06a1bcd4b36ea7",
        "235d9ac9a64641f75d7140b4cb33a3e2a2db3bc7"
      ]
    },
    {
      "id": "2026-06-09-api-totally-new-landing-page",
      "date": "2026-06-09",
      "weekKey": "2026-06-08",
      "title": "Totally new landing page",
      "summary": "Totally new landing page.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Export",
        "Infrastructure",
        "Landing"
      ],
      "commitShas": [
        "68ac24d7ffd1f52dc7a7a05c8fec296ca5f55756"
      ]
    },
    {
      "id": "2026-06-08-api-totally-new-media-menu-canva-stubbed-out-for-now",
      "date": "2026-06-08",
      "weekKey": "2026-06-08",
      "title": "Totally new Media Menu - Canva stubbed out for now",
      "summary": "Totally new Media Menu - Canva stubbed out for now.",
      "tags": [
        "API",
        "Editor",
        "Export",
        "Testing"
      ],
      "commitShas": [
        "13fff3a5f43d31ff9babd273c4cac3e7b7afda7a"
      ]
    },
    {
      "id": "2026-06-08-platform-fixed-access-revoke-message-when-user-was-remove",
      "date": "2026-06-08",
      "weekKey": "2026-06-08",
      "title": "Fixed access revoke message when user was removed from share",
      "summary": "Fixed access revoke message when user was removed from share.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "52a93e069edad049d44e48ced5b3dd64656d37f9"
      ]
    },
    {
      "id": "2026-06-08-projects-recenter-the-create-team-call-to-action",
      "date": "2026-06-08",
      "weekKey": "2026-06-08",
      "title": "Recenter the create team call to action",
      "summary": "Recenter the create team call to action.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "4ae97c858665e3619d24552e3261d762a629e1ea"
      ]
    },
    {
      "id": "2026-06-01-api-centralize-account-limits-and-reveal-in-superuse",
      "date": "2026-06-01",
      "weekKey": "2026-06-01",
      "title": "Centralize account limits and reveal in Superuser",
      "summary": "Centralize account limits and reveal in Superuser.",
      "tags": [
        "API",
        "Account",
        "Export",
        "Projects",
        "Testing"
      ],
      "commitShas": [
        "4858b3c0f8869842abd89cd92931ccef2468c341"
      ]
    },
    {
      "id": "2026-06-01-editor-fix-for-dividers-being-too-hard-to-click",
      "date": "2026-06-01",
      "weekKey": "2026-06-01",
      "title": "Fix for dividers being too hard to click",
      "summary": "Fix for dividers being too hard to click.",
      "tags": [
        "Editor"
      ],
      "commitShas": [
        "2d7439afa8a7dc640b5417da0e353241686e5009"
      ]
    },
    {
      "id": "2026-06-01-platform-fix-free-tier-image-cap-where-offsite-images-wer",
      "date": "2026-06-01",
      "weekKey": "2026-06-01",
      "title": "Fix free tier image cap where offsite images were getting counted in total images allowed",
      "summary": "Fix free tier image cap where offsite images were getting counted in total images allowed.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "4b67d238d1294791b21e9621014b2e01349ea882"
      ]
    },
    {
      "id": "2026-05-31-account-better-profile-update-modal",
      "date": "2026-05-31",
      "weekKey": "2026-05-25",
      "title": "Better profile update modal",
      "summary": "Better profile update modal.",
      "tags": [
        "Account"
      ],
      "commitShas": [
        "c00791512fef8bc75c825012f533799d4d1df0ad"
      ]
    },
    {
      "id": "2026-05-31-api-move-gmail-clipping-risk-to-warning-instead-of-b",
      "date": "2026-05-31",
      "weekKey": "2026-05-25",
      "title": "Move gmail clipping risk to warning instead of being a show stopper",
      "summary": "Move gmail clipping risk to warning instead of being a show stopper.",
      "tags": [
        "API",
        "Export",
        "Projects"
      ],
      "commitShas": [
        "11675c1276a06aaf9bca71dadb4615e0bd1e63ae"
      ]
    },
    {
      "id": "2026-05-31-editor-fix-bug-on-preview-capture-where-some-images-wer",
      "date": "2026-05-31",
      "weekKey": "2026-05-25",
      "title": "Fix bug on preview capture where some images were not showing up",
      "summary": "Support custom fonts, and fix bug on preview capture where some images were not showing up.",
      "tags": [
        "Editor",
        "Export",
        "Infrastructure",
        "Testing"
      ],
      "commitShas": [
        "fe874d96e92fbfa72c3422dd106a46d78b5a29d3",
        "ba982471e4d7cbbc24ee42f41261c0ef075ab853"
      ]
    },
    {
      "id": "2026-05-31-platform-small-fix-to-allow-overflow-of-chrome-highlight-",
      "date": "2026-05-31",
      "weekKey": "2026-05-25",
      "title": "Small fix to allow overflow of chrome highlight ascending tag names",
      "summary": "Small fix to allow overflow of chrome highlight ascending tag names, and added roadmap as markdown and ignored.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "ae388a68e7ab1903db4d562f6be3592c12b74853",
        "7db8766136cd86ba03e636310e413d2264f4d404"
      ]
    },
    {
      "id": "2026-05-30-api-phase-1-account-hardening",
      "date": "2026-05-30",
      "weekKey": "2026-05-25",
      "title": "Phase 1 account hardening",
      "summary": "Phase 1 account hardening.",
      "tags": [
        "API",
        "Account"
      ],
      "commitShas": [
        "36a20231b317f0d4a4ac5c5aab3fbcc4ce3ecdcb"
      ]
    },
    {
      "id": "2026-05-29-api-custom-avatar-colors-stack",
      "date": "2026-05-29",
      "weekKey": "2026-05-25",
      "title": "Custom avatar colors stack",
      "summary": "Custom avatar colors stack, and preflight.",
      "tags": [
        "API",
        "Collaboration",
        "Editor",
        "Export",
        "Infrastructure",
        "Testing"
      ],
      "commitShas": [
        "6540149bbdd1edfdad0fff58f566d7c9b6376c48",
        "a1f6f7e6024fed55eebbc8e6ec6dfb05ed640053"
      ]
    },
    {
      "id": "2026-05-29-editor-keyboard-shortcuts-and-anchor-tag-updates",
      "date": "2026-05-29",
      "weekKey": "2026-05-25",
      "title": "Keyboard shortcuts and anchor tag updates",
      "summary": "Can remove color in text block Props now, and keyboard shortcuts and anchor tag updates.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "85b6ee087c82cd3c114f4374421ba244296e1dfa",
        "49181a8b9b9dca668595451d37e1a1e9c711b04f"
      ]
    },
    {
      "id": "2026-05-29-export-color-blindness-in-preflight",
      "date": "2026-05-29",
      "weekKey": "2026-05-25",
      "title": "Color blindness in preflight",
      "summary": "Color blindness in preflight.",
      "tags": [
        "Export"
      ],
      "commitShas": [
        "32bf424b6f204e2265360698683dd28fec40b21c"
      ]
    },
    {
      "id": "2026-05-29-platform-better-send-test-handling-for-button",
      "date": "2026-05-29",
      "weekKey": "2026-05-25",
      "title": "Better send test handling for button",
      "summary": "Better send test handling for button.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "be5e84642716003dab0a23b9d7a40438db447fb7"
      ]
    },
    {
      "id": "2026-05-25-api-much-better-image-props-for-image-blocks",
      "date": "2026-05-25",
      "weekKey": "2026-05-25",
      "title": "Much better image props for image blocks",
      "summary": "Much better image props for image blocks.",
      "tags": [
        "API",
        "Editor",
        "Testing"
      ],
      "commitShas": [
        "fb972ea7f9bbde37fbbdc72c7f6fb6d87c8114e8"
      ]
    },
    {
      "id": "2026-05-25-editor-deterministic-email-feature-support-tooltips",
      "date": "2026-05-25",
      "weekKey": "2026-05-25",
      "title": "Deterministic email feature support tooltips",
      "summary": "Deterministic email feature support tooltips, and added first email support schema - Feb 2026.",
      "tags": [
        "Editor",
        "Export",
        "Testing"
      ],
      "commitShas": [
        "ed4dba869c087aa5fd98dba50c197bf68bdc0277",
        "f23fc17be3bcc1efb7514f97f89a413ab8531fe9"
      ]
    },
    {
      "id": "2026-05-25-projects-can-now-click-on-starred-projects-to-open-them",
      "date": "2026-05-25",
      "weekKey": "2026-05-25",
      "title": "Can now click on starred projects to open them",
      "summary": "Can now click on starred projects to open them.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "1490eb2a7f23b79dea415d3b75bb6259e79dd10c"
      ]
    },
    {
      "id": "2026-05-24-editor-fix-bug-where-delete-key-fires-fast-better-spaci",
      "date": "2026-05-24",
      "weekKey": "2026-05-18",
      "title": "Fix bug where delete key fires fast; better spacing and divider handling",
      "summary": "New buttons clone their above neighbour's props; Fix bug where delete key fires fast; better spacing and divider handling; and better VML support and outlook width fix.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "6d25a7e63cfccf3f46592f75dad20ab9aadc6a06",
        "0f68cc734b1f23baa957d00f2e1e16a36ea0a362",
        "7430177b3366c5db5bbc9883879708d9e74d6a4b"
      ]
    },
    {
      "id": "2026-05-23-editor-remove-outlook-outter-vml",
      "date": "2026-05-23",
      "weekKey": "2026-05-18",
      "title": "Remove Outlook outter VML",
      "summary": "Remove Outlook outter VML.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "a86b7e653b0cb66f02ec6b1462c76e391ce931f3"
      ]
    },
    {
      "id": "2026-05-22-api-major-refactor-of-properties-panel-to-bucketed-c",
      "date": "2026-05-22",
      "weekKey": "2026-05-18",
      "title": "MAJOR refactor of properties panel to bucketed categorical sections",
      "summary": "Animated gif and webp support, and mAJOR refactor of properties panel to bucketed categorical sections.",
      "tags": [
        "API",
        "Editor",
        "Export",
        "Infrastructure"
      ],
      "commitShas": [
        "c8a3dc350510ddfe7714700cfb5f0923b69ee740",
        "9367392febcc645b9d82cff6107ba5b46d0fe7dc"
      ]
    },
    {
      "id": "2026-05-19-api-api-was-not-returning-full-name-for-invited-memb",
      "date": "2026-05-19",
      "weekKey": "2026-05-18",
      "title": "API was not returning full name for invited members",
      "summary": "API was not returning full name for invited members.",
      "tags": [
        "API"
      ],
      "commitShas": [
        "6ba02f7512bf221aa0e44bd324a046f7ed09a5ba"
      ]
    },
    {
      "id": "2026-05-19-editor-way-better-templating-95-clients-supported-perfe",
      "date": "2026-05-19",
      "weekKey": "2026-05-18",
      "title": "Way better templating - 95% clients supported perfectly",
      "summary": "Invite links 404ing on api server, and way better templating - 95% clients supported perfectly.",
      "tags": [
        "Editor",
        "Export",
        "Landing"
      ],
      "commitShas": [
        "32dd5a7027603c4921e25806b869a6e0ef5c4db2",
        "1b74f3897253bfbb11da361aad4aa0563f5490fe"
      ]
    },
    {
      "id": "2026-05-19-platform-small-bug-when-impersonating-where-we-were-getti",
      "date": "2026-05-19",
      "weekKey": "2026-05-18",
      "title": "Small bug when impersonating where we were getting the setup modal",
      "summary": "Small bug when impersonating where we were getting the setup modal.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "3d8bdc40841d96a8a6a7c977d559b5ebcfbabb4b"
      ]
    },
    {
      "id": "2026-05-15-api-supports-comment-replies-based-on-tier-level",
      "date": "2026-05-15",
      "weekKey": "2026-05-11",
      "title": "Supports comment replies based on tier level",
      "summary": "Html to canvas thumbs for email projects; Supports comment replies based on tier level; Added impersonate to Superuser; More robust auth to fix a bug; Api bug; and better invite handling.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Infrastructure",
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "08e4956c80383a853d21804a169dfefaff935a78",
        "25c1adc872b7f8b14593cfb42a14e3479b64345c",
        "8cecff4d638c53b3386eedb9d126f17a65fa74fb",
        "84b99151de356de25fc6016505bf591719532920",
        "9116d83fd2c209fb6ab9111f6b98142eabdd00b0",
        "b5346aa40367db9804a0ba9a0d9956c9eadba26f"
      ]
    },
    {
      "id": "2026-05-15-platform-fix-editors-loader-bug-firing-again-when-you-tab",
      "date": "2026-05-15",
      "weekKey": "2026-05-11",
      "title": "Fix Editors loader bug firing again when you tab away",
      "summary": "Update avatar stack, and fix Editors loader bug firing again when you tab away.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "bb8ab903c99a0212b58f8ff3459f3b44aea27fd4",
        "bea42dbd7790b2bbb8db79ee9c0a467ea2c15927"
      ]
    },
    {
      "id": "2026-05-15-projects-fix-create-team-call-to-action-vertical-centerin",
      "date": "2026-05-15",
      "weekKey": "2026-05-11",
      "title": "Fix create team call to action vertical centering",
      "summary": "Fix create team call to action vertical centering.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "832d8998c3f0fb27919b65ee77af3ee363dbf4fe"
      ]
    },
    {
      "id": "2026-05-14-api-super-user-bug",
      "date": "2026-05-14",
      "weekKey": "2026-05-11",
      "title": "Super user bug",
      "summary": "Super user bug.",
      "tags": [
        "API",
        "Collaboration",
        "Projects"
      ],
      "commitShas": [
        "21d6120e5c43eedb8dbae426fc1532b3d09d40c9"
      ]
    },
    {
      "id": "2026-05-14-platform-stop-tracking-local-runtime-data-private-avatars",
      "date": "2026-05-14",
      "weekKey": "2026-05-11",
      "title": "Stop tracking local runtime data (private avatars, public-token map)",
      "summary": "Stop tracking local runtime data (private avatars, public-token map).",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "7cc42cbac994e80f663567859ae05da9059471b1"
      ]
    },
    {
      "id": "2026-05-12-editor-font-faces-show-in-properties-dropdown-better-fo",
      "date": "2026-05-12",
      "weekKey": "2026-05-11",
      "title": "Font faces show in properties dropdown; better font face handling in output html",
      "summary": "Font faces show in properties dropdown; better font face handling in output html.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "3ef3af31a2ab3c855fff58c6ace4043fa4ecc034"
      ]
    },
    {
      "id": "2026-05-11-api-can-reuse-images-easily-in-layout-design-now",
      "date": "2026-05-11",
      "weekKey": "2026-05-11",
      "title": "Can reuse images easily in layout design now",
      "summary": "Can reuse images easily in layout design now.",
      "tags": [
        "API",
        "Editor"
      ],
      "commitShas": [
        "f55c2b4775d5424b2f1c3b10a428485bd62b6c53"
      ]
    },
    {
      "id": "2026-05-11-editor-email-testing-9",
      "date": "2026-05-11",
      "weekKey": "2026-05-11",
      "title": "Email testing 9",
      "summary": "Email testing 9; Email testing 8; Email testing 7; Email testing 6; Email testing 5; Email testing 4; Email testing 3; Email testing 2; and email testing 1.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "facf00d1788f40a4489cc98fb020a382903eb3c9",
        "6b4bfbe9a57a0f4e2e2865e9fd607517d8662fc0",
        "2040b0a1743ac9fbed35e8bba2a74b755c0daf56",
        "bcff07575ac5acec51fbfcd579e20f53030de695",
        "91a9fa5fbfda13fb704806522c4df96837ad241a",
        "b7eb927ebedf9be926c2d7d292b0ce17517ac8be",
        "250118d4a164d39369dbf6ebfa6197863ade8955",
        "8d70b05277aef8d9d1ebe6425207f546e0171b63",
        "43c1a3e08ed7678553b8758800d982e9632935b7"
      ]
    },
    {
      "id": "2026-05-09-api-added-robust-projects-controls-and-hardened-role",
      "date": "2026-05-09",
      "weekKey": "2026-05-04",
      "title": "Added robust projects controls and hardened roles",
      "summary": "Added robust projects controls and hardened roles.",
      "tags": [
        "API",
        "Projects"
      ],
      "commitShas": [
        "1a9750cc273bf57ae630516ac1427e593bedf0ab"
      ]
    },
    {
      "id": "2026-05-08-api-preview-dropdown-sizing-bug-fixed",
      "date": "2026-05-08",
      "weekKey": "2026-05-04",
      "title": "Preview dropdown sizing bug fixed",
      "summary": "Better view share handling; Add remove link to role dropdown; Fix shared viewer bug; and preview dropdown sizing bug fixed.",
      "tags": [
        "API",
        "Projects"
      ],
      "commitShas": [
        "e3373293e97678534fac8d7abfa5baf960a46421",
        "9cb2c58dd56eaad51243e57b40fc02f437d68383",
        "0b22a5aa386d868dd8024dabe7bdaf3291da6109",
        "106f8a0d51bab2570466cf099eb65d7f1a976f71"
      ]
    },
    {
      "id": "2026-05-08-editor-textarea-toolbar-wasn-t-appearing",
      "date": "2026-05-08",
      "weekKey": "2026-05-04",
      "title": "Textarea toolbar wasn't appearing",
      "summary": "Fix text block bug for bold etc; Textarea toolbar wasn't appearing; Anchor tag colors; Email layout shadow control; and page layout padding.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "5a6a31fa32eeee4162a73fca172b99cc6d89c7f4",
        "f7e8b8acf8dfeaece3754a49ba9cc64b05ca3561",
        "6876a137ea26f233245f4ff3ae72f610b5247069",
        "91e596aaae522928221a32279e30da148a0f8d07",
        "34a1988fff73974f8b1ad28c028c7320520c453e"
      ]
    },
    {
      "id": "2026-05-08-platform-remove-download-button-for-viewers",
      "date": "2026-05-08",
      "weekKey": "2026-05-04",
      "title": "Remove download button for viewers",
      "summary": "Remove download button for viewers.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "1d3fde26a900a5379fdafc6339bedc33df2d2498"
      ]
    },
    {
      "id": "2026-05-07-api-preview-window-can-send-tests-based-on-teams-acc",
      "date": "2026-05-07",
      "weekKey": "2026-05-04",
      "title": "Preview window can send tests based on Teams account level",
      "summary": "Fix bug for hosting images; Update email tester; and preview window can send tests based on Teams account level.",
      "tags": [
        "API",
        "Account",
        "Editor",
        "Projects"
      ],
      "commitShas": [
        "e5d52751af3d20a2010c6b90a1da16c6294ac6e9",
        "482554d70b63b8629b876fea4c0463b2f595f49e",
        "03af73c0948dc357dbc55ef6c9364341d2d3ce44"
      ]
    },
    {
      "id": "2026-05-07-editor-fix-button-fonts",
      "date": "2026-05-07",
      "weekKey": "2026-05-04",
      "title": "Fix button fonts",
      "summary": "Fix button fonts.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "1a4d591c65dff8ae53f49b0845b3bb03f4338f92"
      ]
    },
    {
      "id": "2026-05-07-platform-indeterminate-loader-and-nice-ux-flow-of-editor-",
      "date": "2026-05-07",
      "weekKey": "2026-05-04",
      "title": "Indeterminate loader and nice UX flow of editor while loading",
      "summary": "Indeterminate loader and nice UX flow of editor while loading.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "9ebccb79ba3ac089626a9f37b3650895c704eb62"
      ]
    },
    {
      "id": "2026-05-06-editor-section-background-images-supported-with-vml-fal",
      "date": "2026-05-06",
      "weekKey": "2026-05-04",
      "title": "Section background images supported with VML fallback",
      "summary": "Section background images supported with VML fallback.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "9295f0a7773aaa8da91dad722141f7ab4e48e66a"
      ]
    },
    {
      "id": "2026-05-06-platform-copy-and-paste-styles-in-right-click-menu",
      "date": "2026-05-06",
      "weekKey": "2026-05-04",
      "title": "Copy and paste styles in right click menu",
      "summary": "Copy and paste styles in right click menu.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "6747647ad58d17c35ae94bbfb087724669ae11fa"
      ]
    },
    {
      "id": "2026-05-05-api-ask-whether-to-bring-collaborators-when-duplicat",
      "date": "2026-05-05",
      "weekKey": "2026-05-04",
      "title": "Ask whether to bring collaborators when duplicating a project",
      "summary": "Ask whether to bring collaborators when duplicating a project; PNG still bugged. grrr; PNG still bugged; Better PNG support; and improved commenting.",
      "tags": [
        "API",
        "Collaboration",
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "26c473b31f2cbea98d5ea1b37c26353f3c42edfc",
        "6e9ba9cac20601a5c41470c6cab5a312cfa30032",
        "40796df56d8dc770f6ece53bea921dcf7670f593",
        "3524dab51451dc598db6e7ffd13aacf7abb6f27a",
        "aabb5bcc8d64c9bb5b742f297845b947d90077ef"
      ]
    },
    {
      "id": "2026-05-05-editor-way-better-utm-and-data-at-tribute-handling-for-",
      "date": "2026-05-05",
      "weekKey": "2026-05-04",
      "title": "Way better UTM and data at tribute handling for links and buttons",
      "summary": "Arrow-key step on numeric property inputs (shift = 8); Disable text selection on editor chrome; Add style pipettes to button properties pane; Resolve lots of lint errors; Better innerHTML on paste for text block atoms; and way better UTM and data at tribute handling for links and buttons.",
      "tags": [
        "Editor",
        "Export",
        "Infrastructure",
        "Projects"
      ],
      "commitShas": [
        "af4e7712986c9d38cdd184219ac176fdbcae4a42",
        "b05f31132bbca8209a21434e3dbf1945d7b8945e",
        "ccc4b7b74524e821fafed064c00fcad9ea966f23",
        "253cea5042dca61127f74c5598af0d104205955c",
        "0c8dc20f01c10b65cfe21714cd0e881078ece0d2",
        "c05ce65acf6852dc84e95e5df8468f8737d8fbaa"
      ]
    },
    {
      "id": "2026-05-05-landing-better-mobile-landing-page",
      "date": "2026-05-05",
      "weekKey": "2026-05-04",
      "title": "Better mobile landing page",
      "summary": "Better mobile landing page.",
      "tags": [
        "Landing"
      ],
      "commitShas": [
        "a4317632749044f215ddfadb95c6224b5e0bb1f5"
      ]
    },
    {
      "id": "2026-05-05-platform-update-browser-title-with-team-and-project-names",
      "date": "2026-05-05",
      "weekKey": "2026-05-04",
      "title": "Update browser title with team and project names",
      "summary": "Update browser title with team and project names.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "50c561e1f6e8be219d3eed87de2d1c036d6aeb0b"
      ]
    },
    {
      "id": "2026-05-05-projects-label-changed-to-beta",
      "date": "2026-05-05",
      "weekKey": "2026-05-04",
      "title": "Label changed to beta",
      "summary": "Label changed to beta.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "4075d386e4657231f6f87bda1db960af26342f0a"
      ]
    },
    {
      "id": "2026-05-04-account-update-avatar-flow-if-editing",
      "date": "2026-05-04",
      "weekKey": "2026-05-04",
      "title": "Update avatar flow if editing",
      "summary": "Update avatar flow if editing.",
      "tags": [
        "Account"
      ],
      "commitShas": [
        "044d564f4d970db146e0f1cf6431398fc2b11fc7"
      ]
    },
    {
      "id": "2026-05-04-api-pass-the-role-to-the-delete-route-so-the-backend",
      "date": "2026-05-04",
      "weekKey": "2026-05-04",
      "title": "Pass the role to the delete route so the backend targets the specific membership",
      "summary": "Better sharing for net new users; Anti spam measures on account email; Lots of access and role rights and revocation handling; Fix for Revocation while in editor showing network error; Avatar bug, fix with bad session scope; Fix collab if shared member is not part of team; Pass the role to the delete route so the backend targets the specific membership; Outgoing system emails open in new tabs now; Prevent self invitation; and fix for project sharing.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "dbe17f6d4ce8e00958c6d3c7b9570398732e6e26",
        "756dd50df95771699a9c5ad0bbf2d29a11827ea8",
        "79f6dc4854e0d3c7f9edd4998eb4b67daef2ffba",
        "ca732e17ce5e8761b403ec80fd520c4988be6e87",
        "ad1252ab044ef1aaf63b64d3cfc328b645ff664c",
        "07dc593d87c1cda4a712995adbfea03670a204ed",
        "7164ef3b30bc3963503b401c189fe764c158b035",
        "0a5d2b06a85d23a1ba322882d6727ffa7e1381f3",
        "f7f8b6e2c5fa7fd9b7611eeb4dd41c25ba349d98",
        "b7748a41933163882cf7a8f84ab26e8e3df8e18c"
      ]
    },
    {
      "id": "2026-05-04-editor-fix-text-atom-dynamic-toolbar-to-not-bleed-off-s",
      "date": "2026-05-04",
      "weekKey": "2026-05-04",
      "title": "Fix text atom dynamic toolbar to not bleed off screen",
      "summary": "Multiple utm key value pairs supported; Fix text atom dynamic toolbar to not bleed off screen; Fix prefilled emails on sign in; Tweaks to landing page sign in modal; and landing page is now static.",
      "tags": [
        "Editor",
        "Export",
        "Infrastructure",
        "Landing"
      ],
      "commitShas": [
        "5d5c71de29a7a68c3d32b035fe4e6c3b7575bb93",
        "dab41d66c2ecce294607d9c7cb7ec9b563262d75",
        "c85d1631369b092b3c93dca24247898927208264",
        "9491cd1560f0a78d484a1e0f71ad9c1c46d3957b",
        "3a229a880af0d56f4cbb0acaca6c0156e8a510e9"
      ]
    },
    {
      "id": "2026-05-04-platform-handle-live-revocation",
      "date": "2026-05-04",
      "weekKey": "2026-05-04",
      "title": "Handle live revocation",
      "summary": "Handle live revocation, and fix device frames.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "ae40224381a379b0696d9760f44c818e5cafe923",
        "4d1050102a549fa49132371d647574168a46fd7a"
      ]
    },
    {
      "id": "2026-05-04-projects-fix-bug-where-share-button-on-teams-doesn-t-fire",
      "date": "2026-05-04",
      "weekKey": "2026-05-04",
      "title": "Fix bug where share button on teams doesn't fire",
      "summary": "Mobile functionality for projects; Fix bug where share button on teams doesn't fire; and better team mgmt ux.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "6e80252f63901a6982b9ba31290a1376ae62c5e9",
        "ca49a065d1798f24aadf65a8de66b6344c21f931",
        "672bd55b5055d355647f19ebef51cedc2462e2fd"
      ]
    },
    {
      "id": "2026-05-03-account-added-google-oauth-verification-meta-tag-to-land",
      "date": "2026-05-03",
      "weekKey": "2026-04-27",
      "title": "Added google Oauth verification meta tag to landing page",
      "summary": "Seo and geo; better content to make google Oauth happy; Added google Oauth verification meta tag to landing page; and google Oauth.",
      "tags": [
        "Account",
        "Landing"
      ],
      "commitShas": [
        "7d70f5c47a699f8162beffde8463019a2724e01d",
        "b8f1bfbea3c8a8ac9ff43766a7b1b6845bb1b359",
        "35b4d9477d28eb5c3b404379737f3e74ed9a3303"
      ]
    },
    {
      "id": "2026-05-03-api-auth-calls-that-must-work-from-the-landing-page-",
      "date": "2026-05-03",
      "weekKey": "2026-04-27",
      "title": "Auth calls that must work from the landing page now use application/x-www-form-urlencoded",
      "summary": "Google auth; Better session handling and quality of life on sign in; Api change - layout image path update; Api change - fix avatar path; Small refactor of server api magic link; Auth calls that must work from the landing page now use application/x-www-form-urlencoded; CORS seeds are now passed through expandWwwApexPairForCors; More server api handling; Added a GET / handler in; Server health tweaks; and made everybody starter tier for now.",
      "tags": [
        "API",
        "Account",
        "Infrastructure",
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "de576fea156f21c73f20db2c69752850c61e7bb4",
        "6802a3ce087fd1c153c68e337efdacc07b33336a",
        "a01cd12b569dfc0381bf088c4d591ddb5d9308e5",
        "8ca2cf65fac010f671f471a0b7f5ddac94238a56",
        "3e95670de73ca82ac1efd55eba2afe665c9d54cb",
        "53aa0d8e3bc879dba2da9b3cd801c51d547616ba",
        "5af92b89e1ae5a1c3baba9573584c976634d8ee5",
        "d08b2e729fe51d8f2e0c0c4ff7036537893f28ca",
        "a832f3da821433c72ed11ad2881d5ca70b6a807a",
        "2d58e14d8a64837fcfaf215786e570da82935569",
        "6dcf0131d51ee2f8e610f7eb337f317095a0e206"
      ]
    },
    {
      "id": "2026-05-03-infrastructure-update-distro",
      "date": "2026-05-03",
      "weekKey": "2026-04-27",
      "title": "Update distro",
      "summary": "Update distro.",
      "tags": [
        "Infrastructure"
      ],
      "commitShas": [
        "6d3fcdc1aa2eff6f8a779b65a04c5dcfc3ec8388"
      ]
    },
    {
      "id": "2026-05-03-landing-fix-empty-root-in-body-so-we-don-t-have-to-wait-",
      "date": "2026-05-03",
      "weekKey": "2026-04-27",
      "title": "Fix empty #root in body so we don't have to wait for React",
      "summary": "Revert landing page visual design; Fix empty #root in body so we don't have to wait for React; and routes for privacy and terms.",
      "tags": [
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "265307a052442882ef6298d1f0d8c0df8b6df4e2",
        "113aef94853d4861f5e4f6281946f2cc552fced5",
        "7023e38fa6ef1084ac7cbff9f3471e05f957403a"
      ]
    },
    {
      "id": "2026-05-03-platform-tweak-to-satisfy-github-s-node-24-migration-but-",
      "date": "2026-05-03",
      "weekKey": "2026-04-27",
      "title": "Tweak to satisfy github's Node 24 migration but keeping node-version 20",
      "summary": "Tweak htaccess; Adding htaccess file for reverse proxy of api subdomain; Tweak to satisfy github's Node 24 migration but keeping node-version 20; Update depoly workflow; and update to deployment workflow.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "b367447a5d446fdf371e7226fc3e1383fd14012d",
        "215c6e799592975815f6ae17c93f851fea834bb8",
        "f77ff6b304fc1bada637f9622da9298e513986fc",
        "b151f9ee326c7e35bf38ede16ea07da7fca12e55",
        "097fbbc564b56daaff5c2576fd5f60f7b174a373"
      ]
    },
    {
      "id": "2026-05-03-projects-add-sign-out-option-to-user-menu",
      "date": "2026-05-03",
      "weekKey": "2026-04-27",
      "title": "Add sign out option to user menu",
      "summary": "Add sign out option to user menu.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "bd42265a7c70406d81452fa312fbc6ea08546595"
      ]
    },
    {
      "id": "2026-05-02-account-button-view-hover-colors",
      "date": "2026-05-02",
      "weekKey": "2026-04-27",
      "title": "Button view hover colors",
      "summary": "Button view hover colors.",
      "tags": [
        "Account",
        "Landing",
        "Projects"
      ],
      "commitShas": [
        "4cd8a659103460283bece6869381bb41eb034ce1"
      ]
    },
    {
      "id": "2026-05-02-api-5mb-image-upload-and-free-tier-auto-rescale",
      "date": "2026-05-02",
      "weekKey": "2026-04-27",
      "title": "5mb image upload and free tier (auto) rescale",
      "summary": "5mb image upload and free tier (auto) rescale, and server save; local undo; collab avatars.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Export",
        "Projects"
      ],
      "commitShas": [
        "1d4c1ea656a5a13258b428a2548ff14c9d9213dc",
        "eff2a7e17e82a3e6ae883eb877a863e709aaa96e"
      ]
    },
    {
      "id": "2026-05-02-editor-remove-delete-modal-new-default-layout-misc-ui",
      "date": "2026-05-02",
      "weekKey": "2026-04-27",
      "title": "Remove delete modal; new default layout; misc UI",
      "summary": "Remove delete modal; new default layout; misc UI.",
      "tags": [
        "Editor",
        "Projects"
      ],
      "commitShas": [
        "94ba41ce3ee795e56de300e9413a51be4db572f2"
      ]
    },
    {
      "id": "2026-05-02-landing-upldate-terms-to-include-promo-use-copy",
      "date": "2026-05-02",
      "weekKey": "2026-04-27",
      "title": "Upldate terms to include promo use copy",
      "summary": "Upldate terms to include promo use copy.",
      "tags": [
        "Landing"
      ],
      "commitShas": [
        "befe65c3c25a1bfe93f564c91599ec72abbbc586"
      ]
    },
    {
      "id": "2026-05-01-api-fixed-feedback-form-added-image-compression",
      "date": "2026-05-01",
      "weekKey": "2026-04-27",
      "title": "Fixed feedback form; added image compression",
      "summary": "Tweak feedback form, and fixed feedback form; added image compression.",
      "tags": [
        "API"
      ],
      "commitShas": [
        "7bd4a7e1882127b1a47213319c0650af95a88a14",
        "1f6ef58c299c07e2e9d00ac74f866701d7e8bb0b"
      ]
    },
    {
      "id": "2026-05-01-platform-pricing-tiers-requirments-doc",
      "date": "2026-05-01",
      "weekKey": "2026-04-27",
      "title": "Pricing tiers requirments doc",
      "summary": "Pricing tiers requirments doc.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "b4b66ecf1a0fc83026a6e4d17b27935264903a26"
      ]
    },
    {
      "id": "2026-04-30-api-admin-superuser-and-projects-page-ui-refinements",
      "date": "2026-04-30",
      "weekKey": "2026-04-27",
      "title": "Admin superuser and Projects page UI refinements",
      "summary": "Admin superuser and Projects page UI refinements.",
      "tags": [
        "API",
        "Account",
        "Projects"
      ],
      "commitShas": [
        "4bb595c194088bc01bd7a2349c755123cb54a8b9"
      ]
    },
    {
      "id": "2026-04-30-platform-new-deployment-pipeline-files-added",
      "date": "2026-04-30",
      "weekKey": "2026-04-27",
      "title": "New deployment pipeline files added",
      "summary": "New deployment pipeline files added.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "fb28366764e32704e550ff9b99f26ad62ea0e5f3"
      ]
    },
    {
      "id": "2026-04-29-api-account-updates-and-initial-roles-with-sharing",
      "date": "2026-04-29",
      "weekKey": "2026-04-27",
      "title": "Account updates and initial roles with sharing",
      "summary": "Account updates and initial roles with sharing.",
      "tags": [
        "API",
        "Account",
        "Infrastructure",
        "Projects"
      ],
      "commitShas": [
        "3bdf47af290258e7c7f8a67953c5f58cad7892c0"
      ]
    },
    {
      "id": "2026-04-27-account-added-sign-in-flow-and-redirect-from-landing-to-",
      "date": "2026-04-27",
      "weekKey": "2026-04-27",
      "title": "Added sign in flow, and redirect from landing to projects for auth users",
      "summary": "Added sign in flow, and redirect from landing to projects for auth users.",
      "tags": [
        "Account",
        "Landing"
      ],
      "commitShas": [
        "6c668a66e9c2dbadc620734e60597695ac1da7c4"
      ]
    },
    {
      "id": "2026-04-27-api-added-feedback-form-wired-to-google-sheets-added",
      "date": "2026-04-27",
      "weekKey": "2026-04-27",
      "title": "Added feedback form; wired to google sheets; added magic link email support via Resend; added magic link email template",
      "summary": "Added feedback form; wired to google sheets; added magic link email support via Resend; added magic link email template, and account creation.",
      "tags": [
        "API",
        "Account",
        "Infrastructure",
        "Landing"
      ],
      "commitShas": [
        "daf7b70be80576281b55de8d65ccbd89d38ce1a9",
        "db8470878164fe238150025ccb3015b36337fbe8"
      ]
    },
    {
      "id": "2026-04-27-landing-initial-landing-page",
      "date": "2026-04-27",
      "weekKey": "2026-04-27",
      "title": "Initial landing page",
      "summary": "Initial landing page.",
      "tags": [
        "Landing"
      ],
      "commitShas": [
        "0e16a07bddcda93e2d1ad7cefd812153073a192f"
      ]
    },
    {
      "id": "2026-04-27-projects-call-to-action-to-create-a-new-project",
      "date": "2026-04-27",
      "weekKey": "2026-04-27",
      "title": "Call to action to create a new project",
      "summary": "Call to action to create a new project.",
      "tags": [
        "Projects"
      ],
      "commitShas": [
        "de6a183e2994254790fa58b925874dc79c43ddd8"
      ]
    },
    {
      "id": "2026-04-25-api-teams-and-projects-workflow-stacks-now-implement",
      "date": "2026-04-25",
      "weekKey": "2026-04-20",
      "title": "Teams and Projects workflow stacks now implemented",
      "summary": "Teams and Projects workflow stacks now implemented, and commenting system implemented.",
      "tags": [
        "API",
        "Account",
        "Collaboration",
        "Editor",
        "Infrastructure",
        "Projects"
      ],
      "commitShas": [
        "8feaae352666a667f6dfb2acfa1e160ba415536f",
        "4cbaf9ec6bdafa5a0ea39ee712547749b4bfff2f"
      ]
    },
    {
      "id": "2026-04-24-api-latest-atom-added-is-now-preselected-in-prop-pan",
      "date": "2026-04-24",
      "weekKey": "2026-04-20",
      "title": "Latest atom added is now preselected in prop pane",
      "summary": "Latest atom added is now preselected in prop pane, and added a new Node backend API.",
      "tags": [
        "API",
        "Editor",
        "Infrastructure"
      ],
      "commitShas": [
        "912df486402d2d761b86863214b9e8151efdb81a",
        "c5718212dcf5b1f1431e4b14670b5f64a14994af"
      ]
    },
    {
      "id": "2026-04-24-editor-major-image-atom-updates-and-improvements",
      "date": "2026-04-24",
      "weekKey": "2026-04-20",
      "title": "Major image atom updates and improvements",
      "summary": "Various UI bug fixes and improvements, and major image atom updates and improvements.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "5828eb5ae46abcd3382e07023359025ab380ac5c",
        "36ffccecc7e2ae04b54e06d91a078ef2ce601e5d"
      ]
    },
    {
      "id": "2026-04-23-editor-realistic-email-header-for-preview-modal",
      "date": "2026-04-23",
      "weekKey": "2026-04-20",
      "title": "Realistic email header for preview modal",
      "summary": "Column bug fixes for VML; Realistic email header for preview modal; Image atoms rounded corners; Horizontal divider atom; and fixed bug in column handling for mobile.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "09c63dee93badddfed3b140bf3b6ac3e1459953f",
        "e6a2b442171886c11acc20dd8fab9cdb2ca762cf",
        "eff1d1273d4ae8c71baf361c694662caf9a68365",
        "8b0fdf25580c405b2ee1e3e42124e1e6b9fe4b57",
        "9b38346b6a69521e46a904a38d6dd2b89b98cb89"
      ]
    },
    {
      "id": "2026-04-23-platform-rounded-corners-on-image-tooltip-added",
      "date": "2026-04-23",
      "weekKey": "2026-04-20",
      "title": "Rounded corners on image tooltip added",
      "summary": "Rounded corners on image tooltip added.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "861961473233c0ff103bf756ce9e00504565318c"
      ]
    },
    {
      "id": "2026-04-22-editor-better-dragging-but-may-want-to-use-a-dragging-l",
      "date": "2026-04-22",
      "weekKey": "2026-04-20",
      "title": "Better dragging, but may want to use a dragging library in the future",
      "summary": "All lucide icons; Better dragging, but may want to use a dragging library in the future; and various bug fixes.",
      "tags": [
        "Editor"
      ],
      "commitShas": [
        "04966028ed4ce73cc7780e8fdc00e88d53a4241b",
        "5b0e9c582842a96ebaa3d821026c1a281d8f6831",
        "3f423232d945096a15fe7ee51c79e70279c801fc"
      ]
    },
    {
      "id": "2026-04-22-landing-favicons",
      "date": "2026-04-22",
      "weekKey": "2026-04-20",
      "title": "Favicons",
      "summary": "Favicons.",
      "tags": [
        "Landing"
      ],
      "commitShas": [
        "980d024337dcd233f4fc06d7ecbe2dc75af2481d"
      ]
    },
    {
      "id": "2026-04-22-platform-fix-highlight-chrome-1px-gap-on-badge",
      "date": "2026-04-22",
      "weekKey": "2026-04-20",
      "title": "Fix highlight chrome 1px gap on badge",
      "summary": "Fix highlight chrome 1px gap on badge.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "48b88f6cbb3d005d216430421f963a1642726d9b"
      ]
    },
    {
      "id": "2026-04-21-editor-added-spacer-and-icon-atoms-graphics-for-others-",
      "date": "2026-04-21",
      "weekKey": "2026-04-20",
      "title": "Added spacer and icon atoms (graphics for others in WIP)",
      "summary": "Added spacer and icon atoms (graphics for others in WIP); Right click menu; and refactored dragging.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "add1dc87f7cf86ab420458c0ea2a8355b7485894",
        "b97ab1dc29c4e98823a16c5211e06da624271874",
        "aaf959b576959e1d56b91b87c3863ffd3a29f5c7"
      ]
    },
    {
      "id": "2026-04-21-platform-fix-drag-ghost-background-color-fill",
      "date": "2026-04-21",
      "weekKey": "2026-04-20",
      "title": "Fix drag ghost background color fill",
      "summary": "Canvas scrollbar changes, and fix drag ghost background color fill.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "566eba5fb77d05710f953556a3cec6a2acbcb7b2",
        "f6df178350e732eecf62c415bf5690fba48aeb36"
      ]
    },
    {
      "id": "2026-04-20-editor-layout-atoms-are-transparent-first",
      "date": "2026-04-20",
      "weekKey": "2026-04-20",
      "title": "Layout atoms are transparent first",
      "summary": "Better components sidebar, and layout atoms are transparent first.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "f12a3e682ed8c1a30add77da72b2090f522a3a0e",
        "b2a1c45adcc601f49dc51ca0e212952396152159"
      ]
    },
    {
      "id": "2026-04-19-editor-better-button-controls-and-added-icon-support-to",
      "date": "2026-04-19",
      "weekKey": "2026-04-13",
      "title": "Better button controls and added icon support to buttons",
      "summary": "Better button controls and added icon support to buttons; Button improvements and responsive updates; and column bug fixes.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "655aea8f6d7fca5367d66d975a966808b89f00c9",
        "6c12e7f72a6ce5d2141b9ce5516cccf2dbcb8289",
        "f6deb368176002ae205a9fc2062a4f6f1474aba7"
      ]
    },
    {
      "id": "2026-04-19-platform-properties-pane-ui-improvements",
      "date": "2026-04-19",
      "weekKey": "2026-04-13",
      "title": "Properties pane UI improvements",
      "summary": "Properties pane UI improvements.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "118c8ba0eca6f3b5fa149762b569de999c156b4f"
      ]
    },
    {
      "id": "2026-04-17-editor-copy-styles-from-another-component",
      "date": "2026-04-17",
      "weekKey": "2026-04-13",
      "title": "Copy styles from another component",
      "summary": "Improved drag highlight; Column controls; Copy styles from another component; and duplicate and better delete.",
      "tags": [
        "Editor"
      ],
      "commitShas": [
        "08aee3d583434e608b4dcf2a4fcb35e5f8f2e55e",
        "3a09871a88696fdfee00a58019bac02eab6c035b",
        "4e3ea1dc2c0d64f29d797756a3f593e98816bcfe",
        "1c38cf5283f3eacf8b05674f8417d32d5504348d"
      ]
    },
    {
      "id": "2026-04-17-platform-type-ui-fix",
      "date": "2026-04-17",
      "weekKey": "2026-04-13",
      "title": "Type ui fix",
      "summary": "Type ui fix.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "102db4321aee2b31aecc267aa1191e2a9ff0b44d"
      ]
    },
    {
      "id": "2026-04-16-editor-text-atom-lots-of-improvements",
      "date": "2026-04-16",
      "weekKey": "2026-04-13",
      "title": "Text atom lots of improvements",
      "summary": "Text atom lots of improvements, and better text atom.",
      "tags": [
        "Editor",
        "Export",
        "Infrastructure"
      ],
      "commitShas": [
        "322716ed467488636042e573a0e82f14d589d0e4",
        "5f765989552464b39cf14dcafd0705440fdd289b"
      ]
    },
    {
      "id": "2026-04-15-editor-preview-modal",
      "date": "2026-04-15",
      "weekKey": "2026-04-13",
      "title": "Preview modal",
      "summary": "Preview modal.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "f97950ac3f29c9b550787f4c29ce5362047982a7"
      ]
    },
    {
      "id": "2026-04-15-platform-ui-tweaks",
      "date": "2026-04-15",
      "weekKey": "2026-04-13",
      "title": "UI tweaks",
      "summary": "UI tweaks.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "0e62ec9a0a0643eb204fde7e46091b2657d3b149"
      ]
    },
    {
      "id": "2026-04-14-editor-added-color-picker-to-color-swatch-atoms",
      "date": "2026-04-14",
      "weekKey": "2026-04-13",
      "title": "Added color picker to color swatch atoms",
      "summary": "Button click tracking; More button props; Added color picker to color swatch atoms; and button props.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "66a919228cdc218539fd2e2437ba3ba7fec095da",
        "c1c14e0916ed0ed2078ea1f432401f3e213e53a2",
        "7accdc5f8253303c91c54511079ac8a0ef26549e",
        "0454f6e0216a61fc41bbc77057b7ce0d937789c1"
      ]
    },
    {
      "id": "2026-04-13-editor-better-sections-can-delete-elements",
      "date": "2026-04-13",
      "weekKey": "2026-04-13",
      "title": "Better sections; can delete elements",
      "summary": "Better sections; can delete elements; Can drag atoms; and 2 and 3 col handling.",
      "tags": [
        "Editor",
        "Export"
      ],
      "commitShas": [
        "0ef4e773f7e6af71b0f9bc0a333de1ef7c95c29b",
        "300e85ee5ca659a0442f72d290858004597a7bee",
        "ec19458c8c916cd341654a893f436de3827f5247"
      ]
    },
    {
      "id": "2026-04-13-platform-bug-fix-layout-prop-pane-input-fields",
      "date": "2026-04-13",
      "weekKey": "2026-04-13",
      "title": "Bug fix: layout prop pane input fields",
      "summary": "Bug fix: layout prop pane input fields; Update dragging animation; and page fill color bug.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "0e545b410c8938b33f2b5013b9097234c359fda5",
        "d24fb5946f599c9a1b3ef99678b11fe28b0daf7f",
        "7552feee767d2d4348c049db8db6ca540eee1182"
      ]
    },
    {
      "id": "2026-04-09-editor-more-props-for-layout",
      "date": "2026-04-09",
      "weekKey": "2026-04-06",
      "title": "More props for layout",
      "summary": "More props for layout, and basic properties pane.",
      "tags": [
        "Editor",
        "Infrastructure"
      ],
      "commitShas": [
        "67b0aa6a3350cdf9f1c3dcfec251f12b5a4e229a",
        "c8d26b0615cbc812aae4265278e9fe542de7a0f0"
      ]
    },
    {
      "id": "2026-04-09-platform-initial-commit-with-plan-for-poc",
      "date": "2026-04-09",
      "weekKey": "2026-04-06",
      "title": "Initial commit with plan for POC",
      "summary": "Update LICENSE; Initial commit; and initial commit with plan for POC.",
      "tags": [
        "Platform"
      ],
      "commitShas": [
        "344ebf44b524a399f5993f13df8c29d8fe96f294",
        "32206dfb688228c08405f7176c6fae559959e5e6",
        "5875c5af2e2203a975d32da21f0c9dcae533e4a5"
      ]
    }
  ]
}
